import { useState } from 'react'

const API_BASE = import.meta.env.VITE_API_BASE_URL || '/api'
const BRAND_COLOR = import.meta.env.VITE_BRAND_PRIMARY_COLOR || '#16a34a'

function useToken() {
  const params = new URLSearchParams(location.search)
  return params.get('token')
}

export default function ResetPage() {
  const [password, setPassword] = useState('')
  const [status, setStatus] = useState<string>('')
  const token = useToken()

  async function submit() {
    setStatus('Sende...')
    try {
      const res = await fetch(`${API_BASE}/auth/password-reset-confirm`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      })
      const json = await res.json()
      setStatus(json.ok ? 'Passwort gesetzt' : (json.error || 'Fehler'))
    } catch (e) {
      setStatus('Fehler beim Senden')
    }
  }

  return (
    <div style={{ fontFamily: 'Inter, Arial, sans-serif', maxWidth: 520, margin: '40px auto', padding: '0 16px' }}>
      <h1 style={{ fontSize: 22 }}>Passwort zurücksetzen</h1>
      <p>Gib dein neues Passwort ein. Der Link kann ablaufen.</p>
      <label>Neues Passwort</label>
      <input value={password} onChange={e => setPassword(e.target.value)} type="password" placeholder="Mindestens 8 Zeichen" style={{ width: '100%', margin: '8px 0 16px', padding: '10px 12px', fontSize: 16 }} />
      <button onClick={submit} style={{ background: BRAND_COLOR, color: '#fff', border: 0, borderRadius: 8, cursor: 'pointer', padding: '10px 12px', fontSize: 16 }}>Passwort setzen</button>
      <p>{status}</p>
    </div>
  )
}